import $ from 'jquery';
import BaseController from './BaseController';
import {submitErrorMessage} from "@ppcp/utils";

/**
 * Cart Controller
 *
 * Handles WooCommerce cart-specific payment flow orchestration.
 * Works with any payment gateway (PayPal, Google Pay, etc.)
 */
class CartController extends BaseController {

    initialize() {
        this.actions.addAction('cart_updated', this.onCartUpdated.bind(this));
        $(window).on('resize', this.doCartHtml.bind(this));
        $(document).on('change', 'input[name^="shipping_method"]', this.onShippingSelected.bind(this));
        super.initialize();
        this.doCartHtml();
    }

    getElementContainer() {
        return document.getElementById(`wc-${this.id}-cart-button-container`);
    }

    onCartUpdated(data) {
        super.initialize();
        this.doCartHtml();
    }

    onShippingSelected() {
        this.storeAttributionValues();
    }

    submitError(error) {
        this.hideProcessing();
        submitErrorMessage(error, 'div.woocommerce-notices-wrapper', 'checkout');
    }

    /**
     * Adjust cart payment container width and float to match checkout button
     */
    doCartHtml() {
        const $button = $('.checkout-button');
        const width = $button.outerWidth();
        if (width && $('.wc-ppcp-cart-payments__container').length) {
            $('.wc-ppcp-cart-payments__container').width(width);
        }
        if ($button.css('float') !== 'none') {
            $('.wc-ppcp-cart-payments__container ').css('float', $button.css('float'));
        }
    }

    onPaymentElementReady() {
        super.onPaymentElementReady();
        $('.wc-ppcp-cart-payments__container').show();
    }
}

export {CartController};
export default CartController;